
export default {

    namespaced: true,

    state: {
        busy: false,
    },

    getters: {
        isBusy: state => state.busy,
    },

    actions: {
        setBusy ({ commit }, val) {
            commit('busy', val);
        },
    },

    mutations: {
        busy ( state, val ) {
            state.busy = val;
        },
    },
}
